module.exports = __webpack_public_path__ + "18a44e9ea1810dc8bc29bdf3669d74f0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mummy-body-s.png
// module id = 1878
// module chunks = 0